var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-des"},[_c('WsIcon',{attrs:{"size":"20"}},[_vm._v("error")]),_c('div',{staticClass:"ws-des__text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }